@if (comparisonItemNamesFiltered$ | async; as groups) {
  <div class="comparison-component">
    @if (showFilterInput) {
      <div class="d-flex mb-2">
        <portal-filter-input class="flex-grow-1" (valueChanged)="filterBy($event)"></portal-filter-input>
      </div>
    }
    <div class="">
      <table class="table table-sm table-stripedd table-hover comparison__table mb-0">
        <tbody class="">
          <!-- comparison groups -->
          @for (group of groups; track group; let groupIx = $index) {
            @if (comparisonSubject[groupIx] != null) {
              <tr class="comparison-header" [class]="{ mute: group.length === 0 }">
                <!-- <td scope="col">#</th> -->
                <!-- comparison subject -->
                <td class="align-middle" scope="col" style="width: 100%">
                  <div>
                    {{ comparisonSubject[groupIx] | translate }}
                    <small class="badge text-bg-light">
                      @if (group.length !== allComparisonItemNames[groupIx].length) {
                        {{ group.length }} / {{ allComparisonItemNames[groupIx].length }}
                      } @else {
                        {{ allComparisonItemNames[groupIx].length }}
                      }
                    </small>
                  </div>
                </td>
                <!-- comparison entities -->
                @for (entity of entityNames[groupIx]; track entity; let entityIx = $index) {
                  <td class="comparison-entity" scope="col">
                    <div>
                      {{ entity | translate }}
                      @if (group.length !== allComparisonItemNames[groupIx].length) {
                        @if (amounts.filteredAmounts[groupIx][entityIx] != null) {
                          <small
                            class="badge text-bg-light"
                            [portalTippy]="
                              'comparisonComponent.entity.optional.count.filtered.vs.total'
                                | translate
                                  : {
                                      optionalTotal: amounts.optionalAmounts[groupIx][entityIx],
                                      optionalFiltered: amounts.filteredOptionalAmounts[groupIx][entityIx],
                                      mandatoryTotal:
                                        amounts.total[groupIx][entityIx] -
                                        amounts.optionalAmounts[groupIx][entityIx],
                                      mandatoryFiltered:
                                        amounts.filteredAmounts[groupIx][entityIx] -
                                        amounts.filteredOptionalAmounts[groupIx][entityIx],
                                    }
                            "
                            [tippyDisabled]="amounts.filteredOptionalAmounts[groupIx][entityIx] == null"
                            >{{ amounts.filteredAmounts[groupIx][entityIx] }} /
                            {{ amounts.total[groupIx][entityIx] }}</small
                          >
                        }
                      } @else {
                        <small
                          class="badge text-bg-light"
                          [portalTippy]="
                            'comparisonComponent.entity.optional.count'
                              | translate
                                : {
                                    optionalTotal: amounts.optionalAmounts[groupIx][entityIx],
                                    mandatoryTotal:
                                      amounts.total[groupIx][entityIx] -
                                      amounts.optionalAmounts[groupIx][entityIx],
                                  }
                          "
                          [tippyDisabled]="amounts.optionalAmounts[groupIx][entityIx] == null"
                          >{{ amounts.total[groupIx][entityIx] }}</small
                        >
                      }
                    </div>
                    <!-- entity description -->
                    <div class="comparison-entity-description font-weight-light text-muted">
                      @if (entityDescriptions[groupIx][entityIx] != null) {
                        <div>
                          <small>{{ entityDescriptions[groupIx][entityIx] | translate }}</small>
                        </div>
                      }
                      <!-- <div>{{ amounts.total[index][entityIx] }}</div> -->
                    </div>
                  </td>
                }
              </tr>
              <!-- comparison items -->
              @for (itemName of group; track itemName; let ix = $index) {
                <tr>
                  <!-- <th scope="row">{{ page.from + ix }}</th> -->
                  <td class="">{{ itemName | translate }}</td>
                  @for (
                    hasItem of comparedItems[groupIx].get(itemName)?.hasItem;
                    track hasItem;
                    let itemIx = $index
                  ) {
                    <td class="text-center">
                      @if (hasItem) {
                        <span
                          [ngClass]="{
                            'badge text-bg-success tooltip-help':
                              comparedItems[groupIx].get(itemName).additionalInfo[itemIx] != null,
                          }"
                          [portalTippy]="
                            comparedItems[groupIx].get(itemName).additionalInfo[itemIx] | translate
                          "
                          [tippyDisabled]="
                            comparedItems[groupIx].get(itemName).additionalInfo[itemIx] == null
                          "
                        >
                          @if (comparedItems[groupIx].get(itemName).isItemOptional[itemIx]) {
                            <!-- <i class="far fa-circle"></i> -->
                            <span>(<i class="far fa-check"></i>)</span>
                            <!-- <span class="fs-3 lh-1">○</span> -->
                            <!-- <span class="fs-3 lh-1">&#9675;</span> -->
                          } @else if (comparedItems[groupIx].get(itemName).explicitValue[itemIx] != null) {
                            {{ comparedItems[groupIx].get(itemName).explicitValue[itemIx] }}
                          } @else {
                            <!-- <span class="fs-3 lh-1">●</span> -->
                            <!-- <span class="fs-3 lh-1">&#9679;</span> -->
                            <i class="far fa-check"></i>
                          }
                        </span>
                      } @else if (comparedItems[groupIx].get(itemName).additionalInfo[itemIx] != null) {
                        <span
                          [ngClass]="{
                            'badge text-bg-danger tooltip-help':
                              comparedItems[groupIx].get(itemName).additionalInfo[itemIx] != null,
                          }"
                          [portalTippy]="
                            comparedItems[groupIx].get(itemName).additionalInfo[itemIx] | translate
                          "
                          [tippyDisabled]="
                            comparedItems[groupIx].get(itemName).additionalInfo[itemIx] == null
                          "
                          ><i class="far fa-minus"></i
                        ></span>
                      }
                    </td>
                  }
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>
    @if (showLegend) {
      <div class="comparison-legend">
        <dl>
          <dt>{{ 'comparisonComponent.legend' | portalTranslate }}</dt>
          <dd class="mb-0">
            <!-- <span class="fs-3 lh-1">&#9679;</span> -->
            <span class="comparison-legend-icon"><i class="far fa-check"></i></span>
            <span class="ms-1">{{ 'comparisonComponent.itemIncluded' | portalTranslate }}</span>
            <!-- <span class="fs-3 lh-1">●</span> -->
          </dd>
          @if (showOptionallyIncludedItemsLegend) {
            <dd>
              <!-- <span class="fs-3 lh-1">&#9675;</span> -->
              <span class="comparison-legend-icon">(<i class="far fa-check"></i>)</span>
              <span class="ms-1">{{ 'comparisonComponent.itemOptionallyIncluded' | portalTranslate }}</span>
              <!-- <span class="fs-3 lh-1">○</span> -->
            </dd>
          }
        </dl>
      </div>
    }
  </div>
}
